import { StrictMode } from 'react'
import { createRoot } from 'react-dom/client'
import './index.css'
import App from './App.tsx'

/**
 * Main Application Entry Point
 * 
 * React Query now handles all authentication state and token management:
 * - Automatic token restoration from localStorage
 * - Background token validation with server
 * - Persistent auth state across page refreshes
 * - Automatic logout on token expiration
 */

createRoot(document.getElementById('root')!).render(
  <App />,
)
